module.exports = __webpack_public_path__ + "static/img/merchant.4a5e2379.png";